import React, { useEffect, useState } from 'react'
import CardCustom from '../custom/card-custom'
import { Col, Row } from 'react-bootstrap'
import { BsFillCircleFill } from 'react-icons/bs'
import ReactApexcharts from 'react-apexcharts'
import { getDashboardProbationAPI } from '../../services/dashboard'

const Colors = [
  {
    color: '#2C5DFE'
  },
  {
    color: '#FFD47F'
  },
  {
    color: '#198754'
  },
  {
    color: '#dc3545'
  }
]
export default function StatusProbation() {
  const [statusProbation, setStatusProbation] = useState([])
  useEffect(() => {
    getDashboardProbation()
  }, [])

  const getDashboardProbation = async () => {
    try {
      const resp = await getDashboardProbationAPI()
      if (!resp) return
      if (resp.status) {
        setStatusProbation(
          resp.result.length > 0
            ? resp.result.map((d, i) => {
                return {
                  name: d.probation,
                  value: d.counts,
                  color: Colors[i].color
                }
              })
            : []
        )
      }
    } catch (error) {}
  }

  const options = {
    stroke: { width: 0 },
    labels: statusProbation.map((d) => d.name),
    colors: statusProbation.map((d) => d.color),

    dataLabels: {
      enabled: false,
      formatter: (val) => `${parseInt(val, 10)}%`,
      name: {
        fontFamily: 'Sarabun'
      }
    },
    legend: {
      show: false,
      position: 'bottom',
      markers: { offsetX: -3 },
      labels: {
        style: {
          fontFamily: 'Sarabun'
        }
      },
      fontFamily: 'Sarabun',
      fontSize: '14px',
      itemMargin: {
        vertical: 3,
        horizontal: 10
      }
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false,
            name: {
              fontSize: '1.2rem'
            },
            value: {
              fontSize: '1.2rem',
              // color: `${isDark ? '#fff' : '#2f3349f2'}`,
              formatter: (val) => `${parseInt(val, 10).toLocaleString()}`
            },

            style: {
              // colors: `${isDark ? '#fff' : '#2f3349f2'}`,
              fontFamily: 'Sarabun'
            }
          }
        }
      }
    },
    responsive: []
  }
  return (
    <CardCustom className="mt-3 mb-3" minHeight="none">
      <div className="p-3">
        <h5 className=" ">Employee</h5>
        <ReactApexcharts
          type="pie"
          options={options}
          series={statusProbation.map((d) => d.value)}
        />
        <Row>
          {statusProbation.map((d, i) => (
            <Col xl={12} key={`${i}-probation`}>
              <div className="d-flex justify-content-between">
                <p className="fw-light font-small-2 text-muted">
                  <BsFillCircleFill style={{ color: d.color }} /> {d.name}
                </p>
                <span>{d.value.toLocaleString()}</span>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </CardCustom>
  )
}
